import format from "string-format";

import { Nullable } from "../base-types";
import { DEFINITIONS } from "../constants";
import { FinalLifeCycleStatus } from "../contracts/content/final-life-cycle-status";
import ErrorMessages from "../error-messages";

export class FinalLifeCycleStatusMapper {
    static fromString(status: Nullable<string>): Nullable<FinalLifeCycleStatus> {
        if (status == null) {
            return null;
        }

        switch (status.toLowerCase()) {
            case DEFINITIONS["FinalLifeCycleStatus"].StatusValues.approved.toLowerCase():
                return FinalLifeCycleStatus.Approved;
            case DEFINITIONS["FinalLifeCycleStatus"].StatusValues.archived.toLowerCase():
                return FinalLifeCycleStatus.Archived;
            case DEFINITIONS["FinalLifeCycleStatus"].StatusValues.created.toLowerCase():
                return FinalLifeCycleStatus.Created;
            case DEFINITIONS["FinalLifeCycleStatus"].StatusValues.rejected.toLowerCase():
                return FinalLifeCycleStatus.Rejected;
            case DEFINITIONS["FinalLifeCycleStatus"].StatusValues.underReview.toLowerCase():
                return FinalLifeCycleStatus.UnderReview;
            default:
                throw format(ErrorMessages.FinalLifeCycleStatusMapper.UnknownStatus, status);
        }
    }

    static toString(status: Nullable<FinalLifeCycleStatus>): Nullable<string> {
        if (status == null) {
            return null;
        }

        switch (status) {
            case FinalLifeCycleStatus.Approved:
                return DEFINITIONS["FinalLifeCycleStatus"].StatusValues.approved;
            case FinalLifeCycleStatus.Archived:
                return DEFINITIONS["FinalLifeCycleStatus"].StatusValues.archived;
            case FinalLifeCycleStatus.Created:
                return DEFINITIONS["FinalLifeCycleStatus"].StatusValues.created;
            case FinalLifeCycleStatus.Rejected:
                return DEFINITIONS["FinalLifeCycleStatus"].StatusValues.rejected;
            case FinalLifeCycleStatus.UnderReview:
                return DEFINITIONS["FinalLifeCycleStatus"].StatusValues.underReview;
            default:
                throw format(ErrorMessages.FinalLifeCycleStatusMapper.UnknownStatus, status);
        }
    }
}
